import { FC } from "react";
import styled from "styled-components";
import mask from "./mask.svg";
import placeholder from "./placeholder.png";

type AvatarProps = {
  src?: string;
  className?: string;
  variant?: "s" | "m" | "l" | "xl" | "xxl";
  customSize?: number;
};

type Variants = {
  [variant: string]: number;
};

const variants: Variants = {
  s: 50,
  m: 64,
  l: 100,
  xl: 150,
  xxl: 250,
};

const Avatar: FC<AvatarProps> = ({
  src,
  customSize,
  variant = "xl",
  ...rest
}) => {
  const size = customSize ? customSize : variants[variant];

  return (
    <Wrapper {...rest}>
      <AvatarBackgroundImage src={src || placeholder} size={size} />
      <Mask src={mask} alt="" customSize={size} />
    </Wrapper>
  );
};

export default Avatar;

const Mask = styled.img<AvatarProps>`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`;

type BackgroundProps = {
  size: number;
  src: string;
};

const AvatarBackgroundImage = styled.div<BackgroundProps>`
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  background-image: url("${(props) => props.src}");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border: 1px solid white;
`;
